import styled, { css, keyframes } from 'styled-components';
import { Label } from 'legacyComponents/styled/lib';
import { truncateWidth } from 'legacyComponents/styled/styleUtils';
import { Icon } from 'components';

export const ResolutionWrapper = styled.div`
  border: 1px solid ${props => props.theme.color.wfGrey300};
  height: 600px;
  overflow: hidden;
`;

export const StepsColumnWrapper = styled.div`
  width: 20%;
  border-right: ${props =>
    props.last ? 'none' : '1px solid rgba(44,45,48,.15)'};
  height: 100%;
  display: inline-block;
  vertical-align: top;
  position: relative;
  overflow-y: scroll;
`;

export const ActionsHeader = styled.div`
  height: 87px;
  padding: 20px;
  border-bottom: 1px solid rgba(44, 45, 48, 0.15);
  cursor: ${props => (props.active ? 'auto' : 'not-allowed')};
  background-color: ${props => props.theme.color.wfWhite};
  position: ${props => (props.first ? 'sticky' : 'static')};
  top: 0;
  > p {
    display: inline-block;
    font-weight: ${props => props.theme.font.weight.xbold};
    color: ${props =>
      props.active ? props.theme.color.wfGrey900 : 'rgba(0,0,0,0.3)'};
    padding: 14px 14px 14px 0;
    > span {
      color: ${props => props.theme.color.wfGrey500};
    }
  }
`;

export const blink = keyframes`
  0% {
    opacity: 1;
   }
   50% {
    opacity: 0.25;
   }
   100% {
     opacity: 1;
   }
`;

const blinkMixin = css`
  animation: ${blink} 1.25s ease-in-out infinite;
`;

export const ContributionStep = styled(ActionsHeader)`
  cursor: ${props => (props.active ? 'pointer' : 'not-allowed')};
  > p {
    color: ${props =>
      props.active ? props.theme.color.primary : `rgba(0,0,0,0.3)`};
    ${props => props.blink && blinkMixin}
  }
  &:hover {
    > p {
      animation: none;
      text-decoration: ${props => (props.active ? 'underline' : 'none')};
    }
  }
`;

export const FileRow = styled.div`
  border-bottom: 1px solid rgba(44, 45, 48, 0.15);
  padding: 20px;
  cursor: pointer;
  position: relative;
  border-left: ${props =>
    props.active ? `4px solid ${props.theme.color.primary}` : 'none'};
  > p {
    font-size: 0.85em;
    overflow-wrap: break-word;
    line-height: 1.2;
    color: ${props => props.theme.color.wfGrey500};
  }
  > p:first-of-type {
    font-weight: 600;
    margin-bottom: 3px;
    font-size: 0.95em;
    color: ${props =>
      props.active ? props.theme.color.primary : 'rgba(0,0,0,0.7)'};
  }
  &:hover {
    > p:first-of-type {
      color: ${props => props.theme.color.primary};
    }
  }
`;

export const ConflictColumn = styled(StepsColumnWrapper)`
  width: 40%;
`;

export const ContribFileHeader = styled.div`
  border-bottom: 1px solid rgba(44, 45, 48, 0.15);
  padding: 20px;
  > div {
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 52px);
    > p {
      margin-left: 10px;
    }
    > p:first-of-type {
      font-weight: 600;
      vertical-align: top;
      margin-top: 2px;
      margin-bottom: 5px;
      ${truncateWidth('calc(100% - 1px)')};
    }
    > p:last-of-type {
      font-size: 0.8em;
      > a {
        color: rgba(0, 0, 0, 0.7);
        text-decoration: underline;
      }
    }
  }
`;

export const LocalFileHeader = styled(ActionsHeader)`
  > h3 {
    text-align: center;
    font-weight: 600;
    padding: 12px;
  }
`;

export const ActionWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  height: 78px;
  border-top: 1px solid rgba(44, 45, 48, 0.15);
  background-color: ${props => props.theme.color.wfWhite};
`;

export const ViewerWrapper = styled.div`
  width: 100%;
  height: calc(600px - 167px);
  position: relative;
  /* Prevent margin inside to collapse */
  overflow: auto;
`;

export const Status = styled(Label)`
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
  background-color: ${props =>
    props.red ? props.theme.color.wfOrange : props.theme.color.primary};
`;

export const NoFile = styled.p`
  line-height: 433px;
  font-style: italic;
`;

export const IconStyled = styled(Icon)`
  position: absolute;
  top: 20px;
  right: 20px;
  color: ${props => props.theme.color.wfGreen};
`;
